import ProductStockListTable from './productStockListTable.container';

export default ProductStockListTable